// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-radio .v-label{line-height:25px}.v-radio{border:1px solid #ddd;border-radius:10px;margin:5px 0;padding:12px}.v-radio .v-input--selection-controls__input{display:none}.v-item--active{background-color:#e8f6f5;border:1px solid #08806d;font-weight:700}.v-item--active .v-label{color:#08806d!important}.radio .error--text .v-radio{border:1px solid red}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
